// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"aa52b68c","977":"fc9c0d98"}[chunkId] + ".chunk.js";
};